import { render, staticRenderFns } from "./ServiceOnline.vue?vue&type=template&id=1f42a0e0&scoped=true&"
import script from "./ServiceOnline.vue?vue&type=script&lang=js&"
export * from "./ServiceOnline.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOnline.vue?vue&type=style&index=0&id=1f42a0e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42a0e0",
  null
  
)

export default component.exports